import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import constant from 'src/app/app.constant';
import { CommonHttpService } from 'src/app/utils/common-http.service';

@Component({
  selector: 'app-filter-delete-template',
  templateUrl: './filter-delete-template.component.html',
  styleUrls: ['./filter-delete-template.component.scss']
})
export class FilterDeleteTemplateComponent implements OnInit {
  filterTemplateList: any = [];
  @Output() resultEvent = new EventEmitter();
  constructor(private toaster: ToastrService, public activeModal: NgbActiveModal, private http: CommonHttpService,) { }

  ngOnInit(): void {
    this.getFilterTemplate();
  }

  getFilterTemplate() {
    this.http.get(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Report.Filter.GetTemplate + constant.Filter.order).subscribe((response: any) => {
      this.filterTemplateList = response.data;
      this.filterTemplateList.map((item: any) => {
        item.showConfirm = false;
      })
    });
  }

  showConfirm(index: number) {
    this.filterTemplateList.forEach((item: any, i: number) => {
      item.showConfirm = i === index ? !item.showConfirm : false;
    });
  }

  hideConfirm(index: number) {
    this.filterTemplateList[index].showConfirm = false;
  }

  deleteTemplate(templateId: any) {
    this.http.deleteDataParams(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Report.Filter.Delete + '?filter_id=' + templateId).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Successfully deleted');
        this.getFilterTemplate();
        this.resultEvent.emit({ deleted: true, filter_id: templateId });
      }
    })
  }
  closeModal() {
    this.activeModal.dismiss();
  }

}
